import * as React from 'react';

import * as styles from './LinkArea.css';
import { clsx } from 'clsx';
import { Link } from '../Link';

interface ILinkAreaProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  href: string;
  preventDefault?: boolean;
  dataName?: string;
}

export function LinkArea({ href, children, dataName, ...divProps }: ILinkAreaProps) {
  return (
    <div {...divProps} className={clsx(styles['container'], divProps.className)} data-name={dataName}>
      <Link href={href} className={styles['link']} />
      {children}
    </div>
  );
}
